import { api } from './api';

// orgId: explicit X-Org-Id; orgId === null: super-admin cross-org call (no header).
const orgCfg = (orgId) => (orgId === null ? { skipOrg: true } : orgId ? { headers: { 'X-Org-Id': orgId } } : {});

// Visible gateways for the caller (scoped like devices via X-Org-Id).
export const listGateways = (params = {}, orgId) =>
  api.get('/gateways', { params, ...orgCfg(orgId) }).then((r) => ({
    ...(r.data || {}),
    gateways: (r.data?.gateways || []).map(normGateway),
  }));

// Detail envelope: { gateway, heard_devices, unregistered_heard, ... }.
export const getGateway = (id, orgId) => api.get(`/gateways/${id}`, orgCfg(orgId)).then(({ data }) => ({
  ...normGateway(data.gateway || data),
  heard_devices: data.heard_devices,
  unregistered_heard: data.unregistered_heard,
}));
const one = (r) => normGateway(r.data?.gateway || r.data);
export const listGatewayHwTypes = () => api.get('/gateways/hw-types').then((r) => (Array.isArray(r.data) ? r.data : []));
export const createGateway = (body, orgId) => api.post('/gateways', body, orgCfg(orgId)).then(one);
export const updateGateway = (id, body, orgId) => api.patch(`/gateways/${id}`, body, orgCfg(orgId)).then(one);
export const deactivateGateway = (id, orgId) => api.post(`/gateways/${id}/deactivate`, null, orgCfg(orgId)).then(one);
export const reactivateGateway = (id, orgId) => api.post(`/gateways/${id}/reactivate`, null, orgCfg(orgId)).then(one);

export function normGateway(g) {
  if (!g) return g;
  const deactivated = !!g.deactivated_at || g.active === false;
  return { ...g, deactivated, status: deactivated ? 'deactivated' : g.status };
}

// Backend routes not deployed yet → the UI shows "coming soon" instead of an error.
export const isNotDeployed = (e) => [404, 405, 501].includes(e?.response?.status);

export const normMac = (s) => String(s || '').replace(/[^0-9a-f]/gi, '').toLowerCase();
export const fmtMac = (hex) => (hex && hex.length === 12 ? hex.match(/.{2}/g).join(':').toUpperCase() : hex || '—');
